import React from "react";
import ReactDOM from "react-dom/client";
// import './css/index.css';
import App from "./App";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

/**
 * Web Vitals
 */
import reportWebVitals from "./reportWebVitals";
import { sendVitalsToDashboard } from "./utils/vitalsLogger";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (window.location.hostname !== "localhost" && window.location.hostname !== '127.0.0.1') {
  reportWebVitals(sendVitalsToDashboard);
}
